import { render, staticRenderFns } from "./settingPage.vue?vue&type=template&id=cc0ebcb0&scoped=true"
import script from "./settingPage.vue?vue&type=script&lang=js"
export * from "./settingPage.vue?vue&type=script&lang=js"
import style0 from "./settingPage.vue?vue&type=style&index=0&id=cc0ebcb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0ebcb0",
  null
  
)

export default component.exports